import type { Model, SquarePlate } from 'metalworks-domain'

import { DistanceDimensionInput } from '@salsita-ai/platform-project-sdk/react'
import { EntityPanel, PropertyContainer } from '@salsita-ai/platform-project-sdk/ui'

import { CustomGenericDimensionInput } from '../fields/CustomGenericDimensionInput'
import {
  BendProperties,
  FinishDirectionProperty,
  FinishProperty,
  HandingProperty,
  HasBendProperty,
  MaterialSwatchProperty,
  NonStandardMaterialWarningWrapper,
  PowderCoatingProperty,
  PowderCoatingWarningWrapper,
  ThicknessProperty,
  cornerRadiusFixableViolations,
} from './shared-property-page-components'

interface Props {
  id: SquarePlate['id']
  hasFinishDirection: boolean
  standard: boolean
  powderCoating: boolean
  $bend: Model.CustomBend | null
}

export const SquarePlatePropertyPage = (props: Props) => {
  const { id, standard, hasFinishDirection, powderCoating, $bend } = props

  return (
    <EntityPanel.Layout
      additionalAction={null}
      header={
        <EntityPanel.Header
          title="Square Plate"
          description="Customise your square plate. You can change the side length, corner radius and thickness of your plate and select your preferred material."
          previewImage={undefined}
          primaryButton={null}
          secondaryButton={null}
        />
      }
    >
      <PropertyContainer.Group spacing="large">
        <MaterialSwatchProperty id={id} />
        <PowderCoatingProperty id={id} />
        <PowderCoatingWarningWrapper powderCoating={powderCoating} />
        <FinishProperty id={id} />
        {hasFinishDirection && <FinishDirectionProperty id={id} />}
        <HandingProperty id={id} />
        <ThicknessProperty id={id} />
        <NonStandardMaterialWarningWrapper standard={standard} />

        <HasBendProperty id={id} />
        {$bend ? (
          <BendProperties bendId={$bend.id} />
        ) : (
          <PropertyContainer.Item title="Length">
            <DistanceDimensionInput
              entityId={id}
              instanceName="sideLength"
              fixableViolations={['cornerRadius.genericDimension.tooLarge']}
            />
          </PropertyContainer.Item>
        )}

        <PropertyContainer.Item title="Corner Radius">
          <CustomGenericDimensionInput
            entityId={id}
            instanceName="cornerRadius"
            fixableViolations={cornerRadiusFixableViolations}
          />
        </PropertyContainer.Item>
      </PropertyContainer.Group>
    </EntityPanel.Layout>
  )
}
